import { SETTINGS } from '../config/common.settings';

export interface ConditionBadge {
  label: string;
  classes: string;
}

const DEFAULT_BADGE: ConditionBadge = {
  label: '-',
  classes:
    'w-full rounded-full px-3 py-1 text-gray-600 bg-gray-200 border border-gray-600 capitalize',
};

const BADGE_CLASS_MAP: Record<string, string> = {
  INC:
    'w-full rounded-full px-3 py-1 text-green-600 bg-green-200 border border-green-600 capitalize',
  EXC:
    'w-full rounded-full px-3 py-1 text-red-600 bg-red-200 border border-red-600 capitalize',
  OPT:
    'w-full rounded-full px-3 py-1 text-blue-600 bg-blue-200 border border-blue-600 capitalize',
  NA:
    'w-full rounded-full px-3 py-1 text-black bg-white border border-black capitalize',
};

export function getConditionBadge(
  conditionType: string | null | undefined,
  conditionTypes = SETTINGS.CONDITION_TYPES.filter(c => (c as any).language === 'en'),
): ConditionBadge {
  if (!conditionType) {
    return DEFAULT_BADGE;
  }

  const condition = conditionTypes.find(({ value }) => value === conditionType);
  if (!condition) {
    return DEFAULT_BADGE;
  }

  return {
    label: condition.label,
    classes: BADGE_CLASS_MAP[condition.value] ?? DEFAULT_BADGE.classes,
  };
}